import React, { useState,useEffect } from "react";
import { toast } from "react-toastify";

const SourceTab = ({updateReviewTabData,reviewTabData}) => {
    const [businessName, setBusinessName] = useState(reviewTabData.business_name || "");
    const [isSubmitting, setIsSubmitting] = useState(false);

    // Sync with latest business_name from props
    useEffect(() => {
        setBusinessName(reviewTabData.business_name || "");
    }, [reviewTabData.business_name]);

    // State to manage the submission status
    const submitReviewForm = async (e) => {
        e.preventDefault();

        if (!businessName.trim()) {
            toast.error("Please enter apple app store url.");
            return;
        }
        updateReviewTabData("business_name", businessName); 
        setIsSubmitting(true);
        // Simulate API delay
        setTimeout(() => {
            setIsSubmitting(false);
        }, 1500); 
        
    };

    return (
        <div className="side-baar-inner-source">
            <span>Source</span>
            <div className="source-serach-baar">
                <div className="google-search-container">
                    <input
                        type="text"
                        placeholder="Enter apple app store url..."
                        value={businessName}
                        onChange={(e) => setBusinessName(e.target.value)}
                    />
                    <button
                        type="button"
                        onClick={submitReviewForm}
                        disabled={isSubmitting}
                        className={isSubmitting ? "disabled" : ""}
                    >
                        {isSubmitting ? "Searching..." : "Search"}
                    </button>
                </div>
            </div>
            <p>
                Enter your Apple App Store app id to display your reviews, for example: 553834731
            </p>
            <p>Note: only .com domain links are supported.</p>
        </div>
    );
};

export default SourceTab;
